import StageFilesEmptyState from './StageFilesEmptyState.component';

export default StageFilesEmptyState;
